import { z } from 'zod';
import { FeatureDetailSchema } from '../types/features';

// GET /applications/:applicationId/features
export namespace GetApplicationFeatures {
  export const paramsSchema = z.object({
    applicationId: z.coerce.number(),
  });

  export const responseSchema = z.object({
    features: z.array(FeatureDetailSchema),
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type Response = z.infer<typeof responseSchema>;
}

// PUT /applications/:applicationId/feature
export namespace UpsertApplicationFeature {
  export const paramsSchema = z.object({
    applicationId: z.coerce.number(),
  });

  export const requestBodySchema = z.object({
    propName: z.string(),
    value: z.string(),
  });

  export const responseSchema = z.object({
    feature: FeatureDetailSchema,
  });

  export type Params = z.infer<typeof paramsSchema>;
  export type RequestBody = z.infer<typeof requestBodySchema>;
  export type Response = z.infer<typeof responseSchema>;
}
